import React, { useMemo } from "react";
import { Switch, Route, useRouteMatch} from "react-router-dom";
import CrudDeleteModal from "./CrudDeleteModal";

export default function CrudRouter({ children, form : Form, service }) {
    const match = useRouteMatch();
    const path = useMemo(() => match.path, [match]);
    if(!path) return null;

    return (
        <Switch>
            <Route path={`${path}/incluir`} render={props => <Form {...props} returnUrl={path}/>} />
            <Route path={`${path}/alterar/:updateId`} component={props => <Form {...props} returnUrl={path}/>} />

            <Route path={path}>
                <>
                    {children}
                    <Route path={`${path}/excluir/:deleteId`} component={props => (
                        <CrudDeleteModal {...props} returnUrl={path} service={service}/>
                    )} />
                </>
            </Route>
            
        </Switch>
    );
}